import React from 'react';
import { Button } from 'react-bootstrap';

const CustomerAccountClinicians = (props) => {


    const showModal = (clinician) => {
        props.showModal({
            open: true,
            model: clinician,
            closeModal: props.closeModal,
            updateClinician: props.updateClinician
        }, 'addUpdateClinician')
    }
    return (
        <>
            <table className='table table-striped table-hover' aria-labelledby="tabelLabel">
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Type</th>
                        <th className="table-fit">
                            <Button
                                variant="primary"
                                size="sm"
                                onClick={() => showModal({"tenantId": props.tenantId})}>
                                Create
                            </Button>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {props.clinicians.map((clinician) =>
                        <tr key={clinician.id}>
                            <td>{clinician.fullName}</td>
                            <td>{clinician.clinicalManager ? "Clinical Manager" : "Clinician"}</td>
                            <td className="table-fit">
                                <Button
                                    className="float-right"
                                    variant="primary"
                                    size="sm"
                                    onClick={() => showModal(clinician)}>Edit</Button>
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </>
    );
}

export default CustomerAccountClinicians;